// src/actions/componentActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../api/http'; // central axios with baseURL & token

export const createComponent = createAsyncThunk(
  'components/createComponent',
  async ({ applicationId, payload }, { rejectWithValue }) => {
    try {
      console.log('Creating component for applicationId:', applicationId);
      console.log('Payload:', payload);

      const { data } = await http.post(
        `/components/${applicationId}/components`,
        payload // axios sets Content-Type: application/json for objects
      );

      console.log('Response from API:', data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchComponents = createAsyncThunk(
  'components/fetchComponents',
  async (applicationId, { rejectWithValue }) => {
    try {
      const { data } = await http.get(`/components/${applicationId}/components`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const updateComponent = createAsyncThunk(
  'components/updateComponent',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      // Adjust URL if your base path is different
      const res = await http.put(`/components/${id}`, data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.error || err.message || 'Failed to update component'
      );
    }
  }
);